/* eslint-disable jsx-a11y/anchor-is-valid */
import Aside from "../../components/Sidebar";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ScrollUp from "../../components/ScrollUp";
import MainTitle from "../../components/MainTitle";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const Articles = () => {
  return (
    <>
      <div className="page d-flex">
        <Aside />
        <div className="content w-full">
          <Header />
          <MainTitle title="المقالات" />
          <div
            className="container-8"
            style={{
              paddingBottom: "60px",
            }}
          >
            <div className="wb-1 m-wb bg-white p-10 m-10">
              <div className="inf inf-2">
                <h3 className="my-h3-2 my-h3">الاغاني في الاستوري</h3>
              </div>
            </div>
            <pre className="my-pre">
              الأغاني في الستوري ! وليه بالأخص؟ طبعًا، خلينا متفقين إن الأغاني
              حرام قطعًا، ولو أنت مش مقتنع فأنا مش جاي في البوست دا أحرمهالك
              ابحث.. لأنها حرام وبأدلة كتيرة .. حتي اقرأ البوست كدا ! في الأيام
              دي مبيخلوش بعض الناس من تحميل استوريات في كل المنصات حرفيًا من
              إنستجرام - فيسبوك - واتس وغيرهم من المنصات اللي بتدعم الستوري.
              ولكن بتصحب هذه الاستوريات أغاني ومهرجنات، ودي في حد ذاتها مجاهرة
              بالمعصية.. حتى لو أصلاً أنت مش بتحب تسمع الأغاني دي، فقط إنك
              بتحطها كدا فا دي برضو مجاهرة بالمعصية. حيث قال رسول الله صلى الله
              عليه وسلم: (كل أمتي معافى إلا المجاهرين). تعال بقي نحلل السيناريو
              بتاع رفعك للستوري دا : أول حاجة نزلت صوره وعليها أغنية لفلان
              وشافها يجي 700 واحد 20 شخص من السمعوا الأغنية دي عجبتهم، فبحث عنها
              وحملها. وفي شخص كان مقرب من ربنا وكان بيصلي وبيذكر ربنا، بس بسبب
              الأغنية دي بعد ازاي؟ الأغاني تعتبر من أبشع الحجات اللي بتأثر على
              النفس والقلب وبتعميه حرفيًا عن ذكر ربنا، غير إنها بتنسيك القرآن
              الكريم. فشخص زي دا كان بيصلي وبيصوم، وبسبب سماع الأغنية اللي أنت
              نزلتها دي أدمنها وبقي بيسمعها بـ3 ساعات يوميًا حرفيًا، فأنت وديت
              الشخص دا في ستين داهية وبيترتب بقي عليه كده حجات تانية والبعد عن
              ربنا حجات أبشع من كده، راح في سكة تانية بقي، وده كله بسببك أنت،
              يعني هتشيل كل فعل يعمله. وفي 7 أشخاص تانيين عجبتهم برضو ونزلوها
              على صورة عندهم استوري، وفي شخص من ال٧ دول عنده ٣٠،٠٠٠ متابع شاف
              الستوري منهم ١٥ ألف؟ وعيد السيناريو اللانهائي دا مع كل حالة
              بتنشرها.. مع العلم إنت حرفيًا بتنشر كل يوم. فأنت تكون قاعد في
              البيت ولا داري بشلال السيئات اللي أنت عاملها فقط من استوري فيها
              أغنية؟ وانت اكيد بتلاحظ احد السيناريوهات دي بتحصل معاك .. الهوا
              انت بتنزل استوري فيها اغنيه معنيه وبعدين وانت بتلف علي الاستوريات
              ال عندك هتلاقي كام واحد كدا حاطط نفس الاغنيه ال انت كنت منزله صح
              ول ايش ؟ وتيجي يوم القيامة وأنت مش عارف اللي أنت عامله بسبب
              الدقائق اللي استغرتها في نشر استوري فيها أغاني؟ قال الله تعالى:
              ("وَلَيَحْمِلُنَّ أَثْقَالَهُمْ وَأَثْقَالًا مَّعَ أَثْقَالِهِمْ ۖ
              وَلَيُسْأَلُنَّ يَوْمَ الْقِيَامَةِ عَمَّا كَانُوا يَفْتَرُونَ")
              طب أعمل إيه في موضوع الستوري دا؟ أول حاجة توب إلى الله وقل معتش
              هنزل أي أغاني تاني وفعلاً متنزلش حاجة زي دي تاني. خش امسح الحاجات
              اللي عندك الستوري المثبتة، عندك اللي فيها أغاني ولا البوستات اللي
              أنت منزلها أو مشيرها، ومليناه أغاني. بدلها بأناشيد دينية، والله
              جميلة، ابحث بس في محرك بحث استوري عن الأغاني أناشيد، وهتلاقي حاجات
              جميلة ولا تخالف دينك. وحطلك في التعليقات بعض الأناشيد اللي
              بستخدمها . تقدر تبحث في اليوتيوب عن " وعي ٢٥ | تجارب شخصية مع
              الموسيقى وآثارها علينا، وأهمية القرآن في تطهير القلب " ودي بودكاست
              من ناس كانو بيعانو من نفس المشكله دي وربنا تاب عليهم ..... هحطلك
              لينك بتعها في التعليقات . طب أنا مبتلي بحب أسمع أغاني كتير، عايز
              أبطل؟ زاحمها بسماع القرآن من صوت شيخ تحبه، تعلم قراءة القرآن
              والتجويد، رتل القرآن، وستجد نفسك تتعلق به خطوة خطوة. القلب لا
              يمتلئ بالنور حتى يطرد الظلمة، وستظل الحرب قائمة والصراع دائرًا
              بينهما إلى أن ينتصر أحدهما على الآخر. شير البوست لعل وعسي تكون
              سببا في توبه احد الاشخاص . وفي النهايه نسال الله الثبات 💜
            </pre>
          </div>
          <ScrollUp />
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Articles;
